var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "update-share-person",
        title:
          _vm._.get(_vm.shareRecord, "sperson.id") +
          " shared with " +
          _vm._.get(_vm.shareRecord, "sgroup.groupName"),
        "header-bg-variant": "success",
        "header-text-variant": "light",
        size: "lg",
        visible: _vm.showModal,
        centered: ""
      },
      on: { hidden: _vm.reset },
      scopedSlots: _vm._u([
        {
          key: "modal-header-close",
          fn: function() {
            return [_c("h4", [_vm._v("X")])]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("br"),
            _vm._v(" "),
            _c("b", [_vm._v("Created At: ")]),
            _vm._v(" " + _vm._s(_vm.getCreatedAt()) + "\n      "),
            _c("br"),
            _vm._v(" "),
            _c("b", [_vm._v("Last Updated: ")]),
            _vm._v(" " + _vm._s(_vm.getLastUpdateDate()) + "\n      "),
            _c("br"),
            _vm._v(" "),
            _c("b", [_vm._v("Current Status: ")]),
            _vm._v(
              " " + _vm._s(_vm.isShared ? "Shared" : "Not Shared") + "\n      "
            ),
            _c("br")
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _vm.isShared && _vm.isAllowedToSharePerson
                ? _c(
                    "b-form",
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "m-3",
                          attrs: {
                            id: "fullUnShare",
                            name: "fullUnShare",
                            value: "true",
                            "unchecked-value": "false",
                            switch: "",
                            inline: "",
                            disabled: ""
                          },
                          model: {
                            value: _vm.fullUnShare,
                            callback: function($$v) {
                              _vm.fullUnShare = $$v
                            },
                            expression: "fullUnShare"
                          }
                        },
                        [
                          _vm._v(
                            "\n          Unshare all associated components of this person record (e.g. screenings, notes, advocates, and external ids).\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isShared && _vm.isAllowedToSharePerson
                ? _c(
                    "b-form",
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          staticClass: "m-3",
                          attrs: {
                            id: "fullShare",
                            name: "fullShare",
                            value: "true",
                            "unchecked-value": "false",
                            switch: "",
                            inline: "",
                            disabled: ""
                          },
                          model: {
                            value: _vm.fullShare,
                            callback: function($$v) {
                              _vm.fullShare = $$v
                            },
                            expression: "fullShare"
                          }
                        },
                        [
                          _vm._v(
                            "\n          Share all associated records (e.g., screenings, notes, and advocates).\n        "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            dismissible: "",
            fade: "",
            show: !_vm._.isEmpty(_vm.sharePersonResponse),
            variant: _vm.sharePersonResponse.error ? "danger" : "success"
          }
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.apiResponseMessage(_vm.sharePersonResponse))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "b-alert",
        {
          attrs: {
            dismissible: "",
            fade: "",
            show: !_vm._.isEmpty(_vm.unsharePersonResponse),
            variant: _vm.unsharePersonResponse.error ? "danger" : "success"
          }
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(
                _vm.apiResponseMessage(_vm.unsharePersonResponse)
              )
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-100",
          attrs: { slot: "modal-footer" },
          slot: "modal-footer"
        },
        [
          _vm.isAllowedToSharePerson
            ? _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { type: "button", variant: "primary", size: "sm" },
                  on: { click: _vm.shareHandler }
                },
                [
                  _c("span", { staticClass: "button-text" }, [
                    _vm._v(_vm._s(_vm.isShared ? "Unshare" : "Share"))
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38c41d62", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38c41d62","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share/UpdateSharePersonModal.vue
// module id = 1597
// module chunks = 0